import React from 'react';
import styled from 'styled-components';

import { Icon } from '@ui/icons/Icon.tsx';
import Logo from '@ui/logo/Logo.tsx';

import { useCSSColors } from '../../../../../src/hooks/useCSSColors.ts';

const TopBar = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ $hideClose }) => ($hideClose ? '0' : '12px')};
  min-height: ${({ $hideClose }) => ($hideClose ? '32px' : 'auto')};
`;

const CloseButton = styled.button`
  color: var(--color-widgetText);
  border: none;
  background: none;
  cursor: pointer;
  font-size: 12px !important;
  padding: 0;
`;

const LogoAndCloseButton = ({ logoUrl, theme, isMobile, clientName, onClose, T, hideClose = false }) => {
  const colors = useCSSColors();
  const showLogo = logoUrl && theme?.header?.hasLogo;

  return (
    <TopBar $hideClose={hideClose}>
      {showLogo && (
        <Logo
          logoHeight={isMobile ? '28px' : theme?.logo?.height}
          alt={clientName}
          url={logoUrl}
          width="auto"
          position={theme?.logo?.centered ? 'center' : 'left'}
          padding={theme?.logo?.padding}
        />
      )}
      {!showLogo && <span>&nbsp;&nbsp;</span>}
      {!hideClose && (
        <CloseButton onClick={onClose} data-testid="CloseButton" aria-label={T('ui:Close')}>
          <Icon className="icon" width={32} height={32} name="close" cdn fillColor={colors.secondaryText} />
        </CloseButton>
      )}
    </TopBar>
  );
};

export default LogoAndCloseButton;
